import request from 'ynf-core-engine/request';
import { configHook } from '@utils';

/**
 * transferCommonRest
 * @param param0
 * @returns
*/
export async function transferCommonRest ({ params = {}, data = {}, ...rest } = {}) {
  /**
   * 默认查询参数
  */
  const defaultQuery = {
    params: {
      feV: 6
    },
    data: {
    }
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);

  try {
    const res = await request({
      url: `${_YPD_SERVICE_}/bill/transferCommonRest`,
      method: 'post',
      ...defaultQuery,
      ...rest
    });
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}
